import Card from './Card.vue';
import { NAME } from './constants';

export const AdvancePay = {
	name: NAME,
	components: {
		Card,
	},
};
